angular.module('harriApp')

    /* Invite to manage modal Directive SBML */
    .directive('sidebarProgressTracker', ["settingsFactory", "$rootScope", "hEvent", function (settingsFactory, $rootScope, hEvent) {
        return {
            restrict: "E",
            replace: 'true',
            templateUrl: '../modules/interview/views/directives/sidebar-progress-tracker.html',
            link: function (scope, element) {
            }
        }
    }])

    /* Schedule Desktop */
    .directive('scheduleInterviewDesktop', ["$rootScope", "DispatcherServices", function ($rootScope, DispatcherServices) {
        return {
            restrict: "E",
            replace: 'true',
            templateUrl: '../modules/interview/views/directives/schedule-interview-desktop.html',
            scope: {
                interviewSlots: '=',
                selectedSlot: '=',
                application: '='
            },
            link: function (scope, element) {


                var interviewCalendar = null;
                var slotParts = 2;
                var nunjucksEngine = DispatcherServices.getNunjucks();

                /***
                 * Render Calendar
                 *
                 *
                 * @param startDate
                 * @param slotParts
                 * @param employerSlots
                 * @param minNavDate
                 * @param maxNavDate
                 */
                scope.renderView = function () {
                    //find time intervals from slots
                    if (scope.interviewSlots && scope.interviewSlots[0]) {
                        var timeDiff = Math.abs(new Date(scope.interviewSlots[0].end_time) - new Date(scope.interviewSlots[0].start_time));
                        slotParts = 60 / (timeDiff / 60000);
                    }

                    var minNavDate = moment(scope.interviewSlots[0].start_time);
                    var timezone = minNavDate.zone();
                    minNavDate.set('minute', 0);
                    minNavDate.set('second', 0);
                    minNavDate.set('millisecond', 0);
                    minNavDate.day(0);
                    minNavDate.zone(timezone);
                    minNavDate.set('hour', InterviewCalendar.hourStart);

                    var startDate = minNavDate.clone();

                    //put max nav date to latest avilable slot
                    var maxNavDate = moment(scope.interviewSlots[scope.interviewSlots.length - 1].start_time);
                    var timezone = maxNavDate.zone();

                    maxNavDate.set('minute', 0);
                    maxNavDate.set('second', 0);
                    maxNavDate.set('millisecond', 0);
                    maxNavDate.day(6);
                    maxNavDate.zone(timezone);
                    maxNavDate.set('hour', InterviewCalendar.hourStart);

                    //save options to render calendar later on
                    renderCalendar(startDate, minNavDate, maxNavDate, scope.interviewSlots, slotParts);
                };

                /***
                 * Render Calendar not to be rendered by outsiders
                 *
                 * @param startDate
                 * @param minNavDate
                 * @param maxNavDate
                 * @param interviewSlots
                 * @param slotParts
                 */
                var renderCalendar = function (startDate, minNavDate, maxNavDate, interviewSlots, slotParts) {
                    interviewCalendar = new InterviewCalendar(nunjucksEngine, {
                        type: 'confirm',
                        elementSelector: '#candidate-interview-calendar',
                        startDate: startDate,
                        minNavDateTime: minNavDate,
                        maxNavDateTime: maxNavDate,
                        selectionType: 'click',
                        employerSlots: interviewSlots,
                        slotParts: slotParts,
                        applyCustomScroller: true,
                        enableSlotsTooltip: true,
                        onSlotChanged: function (slot) {
                            scope.selectedSlot.start_time = parseInt(slot.start_time);
                            scope.selectedSlot.end_time = parseInt(slot.end_time);
                            scope.selectedSlot.id = slot.id;
                        }
                    });
                };

                var updateCalendarOffset = function () {
                    interviewCalendar.updateCalendarOffset();
                };


                // listen for the event in the relevant $scope
                scope.$on('scheduleInterview:visible', function (event) {
                    updateCalendarOffset();
                });

                scope.renderView();

            }
        }
    }])

    /* Schedule Mobile */
    .directive('scheduleInterviewMobile', ["$rootScope", "DispatcherServices", "$timeout", function ($rootScope, DispatcherServices, $timeout) {
        return {
            restrict: "E",
            replace: 'true',
            templateUrl: '../modules/interview/views/directives/schedule-interview-mobile.html',
            scope: {
                interviewSlots: '=',
                selectedSlot: '=',
                showConfirmInterview: '='
            },
            link: function (scope, element) {


                scope.days = [];
                scope.daysInterviews = {};
                scope.STEPS = {
                    'SELECT_DATE': 'SELECT_DATE',
                    'SELECT_TIME': 'SELECT_TIME'
                };

                var findMatchDay = function (slot) {
                    for (var i in scope.days) {
                        if (scope.days[i].date.isSame(slot, 'day')) {
                            return scope.days[i];
                        }
                    }
                    return false;
                };

                for (var i in scope.interviewSlots) {
                    var interviewSlot = moment(scope.interviewSlots[i].start_time);
                    var matchDays = findMatchDay(interviewSlot);
                    if (!matchDays) {
                        var dayToPush = {};
                        dayToPush.date = interviewSlot.clone().hour(0).minute(0).second(0).millisecond(0);
                        dayToPush.slots = [];
                        dayToPush.slots.push(scope.interviewSlots[i]);
                        scope.days.push(dayToPush);
                    } else {
                        matchDays.slots.push(scope.interviewSlots[i]);
                    }
                }


                scope.selectDay = function (day, index) {
                    scope.selectedDay = day;
                    $('.schedule-interview-mobile .days .day').removeClass('selected');
                    $('.schedule-interview-mobile .days #day-' + index).addClass('selected');
                };

                scope.selectTime = function (time, index) {
                    scope.selectedSlot.start_time = time.start_time;
                    scope.selectedSlot.end_time = time.end_time;
                    scope.selectedSlot.id = time.id;
                    $('.schedule-interview-mobile .days .day').removeClass('selected');
                    $('.schedule-interview-mobile .days #day-' + index).addClass('selected');
                };


                scope.goToSelectTimeSlot = function () {
                    if (!scope.selectedDay) {
                        hAlert($filter("translate")("Error"), $filter("translate")("Please, select a date slot to continue!"));
                        return;
                    }
                    showConfirmInterview();
                    scope.activeStep = scope.STEPS.SELECT_TIME;
                };

                scope.backToSelectDay = function () {
                    hideConfirmInterview();
                    scope.activeStep = scope.STEPS.SELECT_DATE;
                };

                var showConfirmInterview = function () {
                    $('.confirm-interview-wrap').show();
                };
                var hideConfirmInterview = function () {
                    $('.confirm-interview-wrap').hide();
                };

                var init = function () {
                    scope.activeStep = scope.STEPS.SELECT_DATE;
                    hideConfirmInterview();
                };

                init();
            }
        }
    }]);
